/*
 * Text for the About panel (top right, next to Contact), in English and
 * Vietnamese. It opens in Vietnamese; visitors can switch with EN / VI.
 * Source: the EPK (short bio and artistic statement, merged into the bio;
 * journey). The name
 * "thangcao" is shown as the title above the bio (AboutTab.js).
 *
 * Journey: to link a release, add `song` (its key in data/songs.js) and put
 * {song} in the text where its title should go; it shows as a link to the
 * song's page.
 */
export const ABOUT = {
  en: {
    bio: [
      "Hi everyone, I'm thangcao (Thắng Cao), a music lover strolling along the journey of chasing my passion. I'm from Đà Nẵng, Vietnam, and I'm a software engineer now studying and working in Toronto, Canada.",
      "Music is a space of my own, where I get to listen to and understand myself a little more on the way to finding who I am. My songs are written from my own real experiences and feelings, in life and in love. I hope these melodies can soothe a heartache or two, and hold on to the present and the memories of youth: mine, and maybe yours too.",
    ],
    genres: "Indie Pop · Ballad · Acoustic · R&B · Neo Soul",
    journeyLabel: "Journey",
    journey: [
      { when: "2013", what: "Got my first guitar and started teaching myself to play." },
      { when: "2020 – 21", what: "Spent the lockdown days learning to sing, write songs and make music on my own." },
      { when: "10 / 2021", what: "My very first song, {song}, came out.", song: "viminhyeuroi" },
      { when: "12 / 2023", what: "{song} came out, and I started finding my own sound.", song: "bucthudau" },
    ],
  },
  vi: {
    bio: [
      "Chào cả nhà, mình là thangcao (Thắng Cao), một người yêu âm nhạc đang dạo bước trên hành trình theo đuổi đam mê. Mình đến từ Đà Nẵng, là một kĩ sư phần mềm hiện đang học tập và làm việc tại Toronto, Canada.",
      "Với mình, âm nhạc là một khoảng trời riêng, nơi mình được lắng nghe và hiểu chính mình hơn trên hành trình tìm lấy bản thân. Những bài hát của mình được viết từ những trải nghiệm và cảm xúc thật trong cuộc sống và tình yêu. Mình mong những lời ca này có thể vỗ về những vết thương lòng, giữ lại những khoảnh khắc của hiện tại và cả những hồi ức thanh xuân, của mình và có lẽ của cả bạn nữa.",
    ],
    genres: "Indie Pop · Ballad · Acoustic · R&B · Neo Soul",
    journeyLabel: "Hành trình",
    journey: [
      { when: "2013", what: "Lần đầu cầm cây đàn guitar và tự mày mò học chơi." },
      { when: "2020 – 21", what: "Những ngày giãn cách, mình bắt đầu tự học hát, viết nhạc và tập làm nhạc." },
      { when: "10 / 2021", what: "Bài hát đầu tiên của mình, {song}, chính thức ra mắt.", song: "viminhyeuroi" },
      { when: "12 / 2023", what: "{song} ra đời, và mình dần tìm thấy chất nhạc của riêng mình.", song: "bucthudau" },
    ],
  },
};
